import { render } from "./SettingsProfile.vue?vue&type=template&id=1c255b9e"
import script from "./SettingsProfile.vue?vue&type=script&lang=js"
export * from "./SettingsProfile.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__